// Meritz menu — à la carte. Prices match POS list (Feb 2026).
import { ASSETS } from "@/data/restaurant";

export const TAKEAWAY_FEE = 200;
export const VAT_RATE = 0.05; // 5% VAT & service charge

export const MENU = [
  {
    id: "rice",
    name: "Rice & Mains",
    blurb: "Plates and bowls — pair with any protein or sauce.",
    image: ASSETS.jollofVeggiePlate,
    items: [
      { name: "Jollof Rice", desc: "Smoky, party-style jollof rice cooked the Meritz way.", price: 1700 },
      { name: "Jollof with Beef", desc: "Smoky jollof rice topped with tender peppered beef.", price: 2400 },
      { name: "Jollof with Fried Chicken", desc: "Generous portion of jollof rice with crispy fried chicken.", price: 3700 },
      { name: "White Rice and Chicken Sauce", desc: "Steamed white rice paired with rich chicken sauce.", price: 3500 },
      { name: "Rice and Stew", desc: "Plain rice with our signature tomato stew.", price: 2000 },
      { name: "Rice and Banga Stew", desc: "White rice with native banga (palm-fruit) stew.", price: 2000 },
      { name: "Fried Rice", desc: "Stir-fried rice with vegetables and seasoning.", price: 2000 },
      { name: "Native Rice", desc: "Palm-oil native rice with smoked fish and crayfish.", price: 2000 },
      { name: "Noodles", desc: "Stir-fried noodles with veg & egg.", price: 3000 },
      { name: "White Yam and Egg Sauce", desc: "Boiled white yam served with peppered egg sauce.", price: 2500 },
      { name: "Abacha with Fried Fish or Kpomo", desc: "African salad with fried fish or kpomo (your choice).", price: 1500 },
      { name: "Breakfast Package", desc: "Full Meritz breakfast — perfect to start your day.", price: 6000 },
      { name: "Porridge Beans", desc: "Soft, peppered beans pottage.", price: 1500 },
      { name: "Porridge Yam", desc: "Native yam porridge with palm oil & pepper.", price: 2000 },
    ],
  },
  {
    id: "soups",
    name: "Soups & Swallow",
    blurb: "Native pots — comes with any swallow of choice (fufu, eba, semo, or pounded yam).",
    image: ASSETS.bitterLeafSoup,
    items: [
      { name: "Egusi Soup with Swallow", desc: "Melon-seed classic with any swallow of your choice.", price: 2500 },
      { name: "Afang Soup with Swallow", desc: "Leafy, rich Calabar-style soup with any swallow.", price: 3000 },
      { name: "Okra Soup with Swallow", desc: "Light, fresh draw soup with any swallow.", price: 3000 },
      { name: "Bitter Leaf Soup with Swallow", desc: "Hearty traditional Igbo onugbu with any swallow.", price: 2500 },
      { name: "Oha Soup with Swallow", desc: "Native Igbo oha soup with any swallow.", price: 2500 },
    ],
  },
  {
    id: "pepper-soup",
    name: "Pepper Soup",
    blurb: "Warm, peppery, served with boiled plantain.",
    image: ASSETS.pepperSoup,
    items: [
      { name: "Fish Pepper Soup", desc: "Fresh fish in native spices, served with boiled plantain.", price: 4000 },
      { name: "Goat Meat Pepper Soup", desc: "Slow-cooked goat in spiced broth.", price: 3000 },
    ],
  },
  {
    id: "proteins",
    name: "Proteins & Grills",
    blurb: "Pick a portion — add it to any plate.",
    image: ASSETS.vegetableChicken,
    items: [
      { name: "Small Fried Chicken", desc: "Single portion of crispy fried chicken.", price: 1500 },
      { name: "Big Fried Chicken", desc: "Larger portion of crispy fried chicken.", price: 2000 },
      { name: "Fried Fish", desc: "Crispy fried mackerel — perfect side.", price: 1500 },
      { name: "Beef", desc: "Tender peppered beef portion.", price: 700 },
      { name: "Suya (per stick)", desc: "Spicy beef skewer with yaji spice — priced per stick.", price: 1000 },
      { name: "Chicken Vegetable Sauce", desc: "Whole chicken cooked in rich vegetable sauce — family size.", price: 18000 },
      { name: "Barbecue (Small)", desc: "Small barbecue platter — perfect for 2-3 people.", price: 12000 },
      { name: "Barbecue (Large)", desc: "Large barbecue platter — feeds 4-6 people.", price: 15000 },
    ],
  },
  {
    id: "shawarma",
    name: "Shawarma & Specials",
    blurb: "Hand-rolled wraps, freshly grilled.",
    image: ASSETS.shawarmaPress,
    items: [
      { name: "Chicken Shawarma", desc: "Fresh wrap with grilled chicken & signature sauce.", price: 4500 },
      { name: "Beef Shawarma", desc: "Fresh wrap with peppered beef & signature sauce.", price: 4000 },
      { name: "Special Shawarma", desc: "Loaded shawarma — chicken + beef + extra sauce.", price: 6000 },
      { name: "Meritz Special", desc: "Our signature house dish — a chef's surprise!", price: 7500 },
    ],
  },
  {
    id: "sides",
    name: "Sides",
    blurb: "Add a little extra to any meal.",
    image: null,
    items: [
      { name: "Fried Plantain (per spoon)", desc: "Sweet ripe plantain, fried golden — priced per spoon.", price: 500 },
      { name: "Salad", desc: "Garden salad, side portion.", price: 500 },
      { name: "White Beans", desc: "Soft boiled beans, side portion.", price: 500 },
    ],
  },
];

export const DRINKS = {
  soft: {
    title: "Soft Drinks",
    items: [
      { name: "Hollandia 1L Yoghurt", desc: "Family pack", price: 2500 },
      { name: "Exotic", desc: "Premium juice blend", price: 2200 },
      { name: "5Alive", desc: "Fruit juice pack", price: 2000 },
      { name: "Diva Yoghurt", desc: "Chilled, creamy", price: 1000 },
      { name: "Dudu Yoghurt", desc: "Sweet, smooth", price: 1000 },
      { name: "Malt", desc: "Bottle, ice-cold", price: 800 },
      { name: "Coke", desc: "Bottle, chilled", price: 500 },
      { name: "Fanta", desc: "Bottle, chilled", price: 500 },
      { name: "Sprite", desc: "Bottle, chilled", price: 500 },
      { name: "Pepsi", desc: "Bottle, chilled", price: 500 },
      { name: "Bottle Water", desc: "Pure table water", price: 300 },
    ],
  },
  alcohol: {
    title: "Alcohol",
    items: [
      { name: "Big Heineken", desc: "Premium imported lager", price: 1600 },
      { name: "Castle Lite", desc: "Light, crisp lager", price: 1500 },
      { name: "Star", desc: "Nigerian classic lager", price: 1200 },
      { name: "Medium Stout (Guinness)", desc: "Smooth dark stout", price: 1200 },
      { name: "Trophy", desc: "Smooth, easy-drinking", price: 1100 },
      { name: "Budweiser", desc: "Imported lager", price: 1500 },
      { name: "Smirnoff Ice", desc: "Vodka mixer, chilled", price: 900 },
      { name: "Desperado", desc: "Tequila-flavoured beer", price: 1400 },
      { name: "Origin", desc: "Bitter, full-bodied lager", price: 1500 },
      { name: "Legend Stout", desc: "Smooth, rich Nigerian stout", price: 1500 },
      { name: "Small Heineken", desc: "Mini bottle", price: 1300 },
      { name: "Flying Fish", desc: "Apple/lemon flavoured", price: 1100 },
      { name: "Tiger", desc: "Crisp, refreshing lager", price: 1100 },
      { name: "Star Radler", desc: "Lemon-citrus lager", price: 1000 },
      { name: "Life Lager", desc: "Eastern Nigeria favourite", price: 1000 },
      { name: "Gulder", desc: "Bold, premium lager", price: 1200 },
      { name: "Hero", desc: "Eastern Nigeria's favourite", price: 1000 },
      { name: "Small Stout", desc: "Mini Guinness", price: 1000 },
      { name: "Palm Wine", desc: "Tapped fresh, served chilled", price: 1500 },
    ],
  },
};

export const formatNaira = (n) =>
  "₦" + Number(n).toLocaleString("en-NG", { maximumFractionDigits: 0 });
